<template>
    <div class="page-container">
        <div class="fixed-header">
            <Content />
        </div>
        <div class="scrollable-content">
            <HelloWorld title="Biology" background-color="#FB585B" />
            <div class="nav-container">

                <div class="nav">
                    <div class="two">
                        <div v-for="(tab, index) in tabs" :key="index" class="tab-item"
                            :class="{ active: activeTab === index }" @click="switchTab(index)"
                            @mouseenter="hoveredTab = index" @mouseleave="hoveredTab = null">
                            <span :class="{ 'tab-name': true, 'active-name': activeTab === index }">{{ tab.name
                                }}</span>
                            <div v-if="activeTab === index || hoveredTab === index" class="triangle"></div>
                        </div>
                    </div>

                </div>
            </div>


            <middleVideo />
        </div>
        <div class="fixed-footer">
            <Concat />
        </div>
    </div>
</template>

<script setup>
import middleVideo from './middle-video.vue';
import Arrowhead from '../components/Arrowhead.vue'
import Concat from '../components/Concat.vue'
import Content from '../components/Content.vue'
import HelloWorld from '@/components/HelloWorld.vue';
import videoSource from '../assets/videos/video.mp4'
import { useRouter } from 'vue-router';
import { computed } from 'vue';
const router = useRouter();

import { ref, onMounted } from 'vue'

// 当前激活的 tab
const activeTab = ref(0)

//当前悬停的tab
const hoveredTab = ref(null)
// 定义 tabs
const tabs = ref([
    { name: 'Past year papers', path: '/microeconomics' }, // 修改为跳转到 /microeconomics
    { name: 'Difficulty', path: '/microeconomics' },           // 保持跳转到 /difficulty
    { name: 'Knowledge points', path: '/physics1' },
    { name: 'Video & Notes', path: '/physics1' }          // 修改为跳转到 /physics1
])


// 跳转到视频详情页并传递item数据
const goToVideoDetail = (item) => {

    router.push({
        path: "/videosd",
        query: {
            item: JSON.stringify(item)
        }

    });

}
</script>

<style scoped>
.page-container {
    display: flex;
    flex-direction: column;
    height: 100vh;
}

.fixed-header {
    flex-shrink: 0;
}

.scrollable-content {
    flex: 1;
    overflow-y: auto;
    max-height: 1732px;
}

.fixed-footer {
    flex-shrink: 0;
}

/* 2222222 */
.nav-container {
    width: 100vw;
    display: flex;
    justify-content: center;



    .nav {
        width: 1200px;
        margin: 0px 120px 0px 120px;
    }
}

.two {
    width: 100%;
    height: 64px;
    background: #000000;
    border-radius: 0px 0px 0px 0px;
    display: flex;

    .tab-item {
        margin: 20px 0px 19px 24px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #FFFFFF;
        text-align: left;
        cursor: pointer;
        padding: 0 10px;
        transition: all 0.3s ease;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .tab-item:first-child {
        margin-left: 24px;
    }

    .tab-item:not(:first-child) {
        margin-left: 155px;
    }

    .tab-item:hover {
        opacity: 0.8;

    }

    .tab-name {
        white-space: nowrap;
    }

    .tab-name.active-name {
        font-weight: 800;
    }




    .triangle {
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-bottom: 10px solid white;
        margin-top: 8px;
    }
}

@import '../pages/index-b.css'
</style>